<template>
  <div>
    <form @submit.prevent>
      <div class="row">
        <div class="col-md-8 col-xs-12"></div>
        <div class="col-12">
          <b-form-group class="">
            <div class="d-flex align-items-center">
              <label class="label-table m-0 flex-1-0">Danh sách vai trò</label>
              <base-button
                v-if="!readonly"
                class="btn search-information-btn d-block"
                @click="moFormThemDanhSachVaiTro()"
                button="Thêm vai trò"
              >
                Thêm vai trò
              </base-button>
              <base-button
                :disabled="selectedVaiTro.length === 0"
                class="btn search-information-btn d-block"
                button="Xóa vai trò đã chọn"
                @click="moFormXoaDanhSachVaiTro()"
              >
                Xóa vai trò đã chọn
              </base-button>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="box-form-result">
        <DataTable
          :value="danhSachVaiTroNoiBo"
          :loading="isLoadingTable"
          :selection.sync="selectedVaiTro"
          :auto-layout="true"
        >
          <Column
            field="id"
            headerStyle="width: 40px"
            header=""
            bodyStyle="text-align: center"
            selectionMode="multiple"
            :filter-header-class="readonly ? 'd-none' : ''"
            :body-class="readonly ? 'd-none' : ''"
            :header-class="readonly ? 'd-none p-2' : 'p-2'"
          >
          </Column>
          <Column
            field="stt"
            dataKey="stt"
            headerStyle="width: 40px"
            headerClass="p-2"
            header="STT"
            bodyStyle="text-align: center"
          >
            <template #filter> </template>
            <template #body="slotProps">
              <span>{{
                (requestInformation.pageIndex - 1) *
                  requestInformation.pageSize +
                slotProps.index +
                1
              }}</span>
            </template>
          </Column>
          <Column
            filterMatchMode="custom"
            field="name"
            header="Tên vai trò"
            headerStyle="minWidth: 200px"
          >
            <template #filter>
              <InputText
                type="text"
                class="p-column-filter"
                placeholder="Tìm kiếm"
                v-model="requestForm.Name"
                @change="layDanhSachVaiTro"
              />
            </template>
            <template #body="slotProps">
              <span>{{ slotProps.data.name }}</span>
            </template>
          </Column>
          <Column
            filterMatchMode="custom"
            field="displayName"
            header="Tên hiển thị"
            headerStyle="minWidth: 200px"
          >
            <template #filter>
              <InputText
                type="text"
                class="p-column-filter"
                placeholder="Tìm kiếm"
                v-model="requestForm.displayName"
                @change="layDanhSachVaiTro"
              />
            </template>
            <template #body="slotProps">
              <span>{{ slotProps.data.displayName }}</span>
            </template>
          </Column>
          <Column
            filterMatchMode="custom"
            field="appName"
            header="Tên ứng dụng"
            headerStyle="minWidth: 200px"
          >
            <template #filter>
              <InputText
                type="text"
                class="p-column-filter"
                placeholder="Tìm kiếm"
                v-model="requestForm.appName"
                @change="layDanhSachVaiTro"
              />
            </template>
            <template #body="slotProps">
              <div v-html="slotProps.data.appName"></div>
            </template>
          </Column>
          <Column
            filterMatchMode="custom"
            field="thaoTac"
            header="Thao tác"
            headerStyle="width: 100px"
            v-if="!readonly"
          >
            <template #body="slotProps">
              <div class="text-center">
                <font-awesome-icon
                  icon="trash-alt"
                  v-b-popover.hover.top="'Xóa vai trò khỏi nhóm'"
                  class="cursor-pointer color-red ml-2"
                  @click="moFormXoaVaiTro(slotProps.data.roleId)"
                />
              </div>
            </template>
          </Column>
          <template #empty
            ><div class="text-center">Không có dữ liệu</div></template
          >
          <template #loading
            ><div class="text-center">Đang tải dữ liệu ...</div>
          </template>
        </DataTable>
        <BasePagination
          class="mt-3"
          :total-pages="danhSachVaiTro.totalPage"
          :total-rows="danhSachVaiTro.totalCount"
          :current-page="requestInformation.pageIndex"
          @changePages="onChangePages($event)"
          @changeNum="onChangeNum($event)"
        />
      </div>
    </form>
    <XoaVaiTroModal @xoaVaiTro="xoaDanhSachVaiTro" />
    <b-modal
      id="them-vai-tro-modal"
      size="xl"
      title="Thêm vai trò vào nhóm người dùng"
      :hide-footer="true"
      centered
    >
      <DanhSachVaiTroKhongThuocGroup
        ref="danhSachVaiTroKhongThuocGroup"
        :key="`vai-tro-khong-thuoc-nguoi-dung-${groupId}`"
        :groupId="groupId"
        :appId="appId"
        @close="dongFormThemDanhSachVaiTro"
        @laydanhSachVaiTroTheoGroup="layDanhSachVaiTro"
        @themVaiTroVaoGroup="xacNhanThemVaiTro"
      />
    </b-modal>
    <b-modal
      id="xac-nhan-them-vai-tro-modal"
      size="lg"
      title="Xác nhận thêm vai trò vào nhóm người dùng"
      :hide-footer="true"
      centered
    >
      <div style="text-align: center" class="float-right mt-4">
        <div>
          Thêm vai trò <strong>"{{ tenVaiTroCanThem }}"</strong> vào nhóm sẽ
          thêm quyền của ứng dụng chung và người dùng của vai trò vào nhóm người
          dùng này, bạn chắc chắn muốn thêm vai trò này vào nhóm người dùng?
        </div>
        <div style="text-align: center" class="float-right mt-4">
          <base-button
            button="Xác nhận"
            size="sm"
            class="btn search-information-btn mb-3 mr-2"
            variant="primary"
            @click="themVaiTroVaoGroup"
            >Tạo</base-button
          >
          <base-button
            button="Đóng"
            size="sm"
            class="btn search-information-btn mb-3 mr-2"
            variant="outline-secondary"
            @click="dongXacNhanThemVaiTro"
            >Hủy
          </base-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import XoaVaiTroModal from "@/components/pages/quan-tri-he-thong/vai-tro/XoaVaiTroModal";
import DanhSachVaiTroKhongThuocGroup from "@/components/pages/quan-tri-he-thong/vai-tro/DanhSachVaiTroKhongThuocGroup";
import BasePagination from "@/components/common/BasePagination";
import {
  ROUTE_NAME,
  MENU_ROUTE_NAME,
  BANG_VAI_TRO,
  BO_QUA_BUTTON_LABEL,
} from "@/constants/constants";
import {
  THEM_VAI_TRO_VAO_GROUP_THANH_CONG,
  XOA_VAI_TRO_THUOC_GROUP_THANH_CONG,
} from "@/constants/message";
import _cloneDeep from "lodash/cloneDeep";
import { mapGetters } from "vuex";
import _isNil from "lodash/isNil";
import _isEmpty from "lodash/isEmpty";
export default {
  name: "DanhSachVaiTroTheoGroup",
  components: {
    XoaVaiTroModal,
    BasePagination,
    DanhSachVaiTroKhongThuocGroup,
  },
  data() {
    return {
      MENU_ROUTE_NAME: `${MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.VAI_TRO}`,
      ROUTE_NAME: ROUTE_NAME,
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      requestInformation: {
        pageSize: 10,
        pageIndex: 1,
      },
      requestInternalForm: {},
      isLoadingTable: true,
      deletedId: null,
      groupId: null,
      danhSachIdVaiTroDaChon: [],
      danhSachIdVaiTroMuonXoa: [],
      danhSachIdVaiTro: [],
      selectAllRowsInPage: false,
      requestForm: {},
      selectedVaiTro: [],
      tenVaiTroCanThem: "",
    };
  },
  props: {
    readonly: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Boolean | null,
      required: false,
    },
    chiTietGroup: {
      type: Object,
      require: false,
    },
    appId: {
      type: String,
      default: "",
    },
  },
  watch: {
    danhSachVaiTro: {
      handler() {
        this.danhSachIdVaiTro = this.layDanhSachIdVaiTro(this.danhSachVaiTro);
      },
      immediate: true,
    },
    chiTietGroup: {
      handler() {
        if (!_isNil(this.chiTietGroup)) {
          this.groupId = this.chiTietGroup.id;
          this.layDanhSachVaiTro();
        }
      },
    },
    selectedVaiTro: {
      handler() {
        this.danhSachIdVaiTroDaChon = (this.selectedVaiTro || []).map(
          (x) => x.id
        );
      },
      deep: true,
    },
    appId: {
      handler() {
        this.layDanhSachVaiTro();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      danhSachVaiTro: "group/danhSachVaiTroTheoGroup",
    }),
    danhSachVaiTroNoiBo() {
      return this.layDanhSachVaiTroNoiBo(this.danhSachVaiTro);
    },
    fieldName() {
      return this.getFieldName();
    },
    hasPageData() {
      return !_isEmpty(this.danhSachVaiTro);
    },
    danhSachVaiTroDaChon: {
      get: function () {
        let danhSachVaiTro = this.danhSachVaiTroNoiBo.filter((vaiTro) =>
          this.danhSachIdVaiTroDaChon.includes(vaiTro.id)
        );
        return danhSachVaiTro.map((vaiTroDaChon, index) => {
          return Object.assign({}, vaiTroDaChon, {}, { stt: index + 1 });
        });
      },
      set: function () {},
    },
  },
  created() {
    this.layDanhSachVaiTro();
  },
  methods: {
    onChangeNum(pageSize) {
      this.requestInformation.pageIndex = 1;
      this.requestInformation.pageSize = pageSize;
      this.layDanhSachVaiTro();
    },
    onChangePages(page) {
      this.requestInformation.pageIndex = page;
      this.layDanhSachVaiTro();
    },
    moFormThemDanhSachVaiTro() {
      this.$bvModal.show("them-vai-tro-modal");
    },
    dongFormThemDanhSachVaiTro() {
      this.$bvModal.hide("them-vai-tro-modal");
    },
    xacNhanThemVaiTro() {
      let name = this.$refs["danhSachVaiTroKhongThuocGroup"].getTenVaiTro;
      this.tenVaiTroCanThem = name;
      this.$bvModal.show("xac-nhan-them-vai-tro-modal");
    },
    dongXacNhanThemVaiTro() {
      this.$bvModal.hide("xac-nhan-them-vai-tro-modal");
    },
    themVaiTroVaoGroup() {
      let danhSachVaiTroThemMoi =
        this.$refs["danhSachVaiTroKhongThuocGroup"].danhSachIdVaiTroThemMoi;
      if (_isEmpty(danhSachVaiTroThemMoi)) {
        return;
      }

      const payload = {
        Id: this.chiTietGroup.id,
        Code: this.chiTietGroup.code,
        Name: this.chiTietGroup.name,
        AppId: this.chiTietGroup.appId,
        Description: this.chiTietGroup.description,
        LstUserInGroup: null,
        LstRole: danhSachVaiTroThemMoi,
        LstPermission: null,
      };
      this.$store
        .dispatch("group/addMapping", payload)
        .then(() => {
          this.$toasted.clear();
          this.$toasted.global.showSuccessMessage({
            message: THEM_VAI_TRO_VAO_GROUP_THANH_CONG,
          });
          this.$bvModal.hide("them-vai-tro-modal");
          this.dongXacNhanThemVaiTro();
          this.layDanhSachVaiTro();
        })
        .catch(() => {
          this.dongXacNhanThemVaiTro();
          this.$bvModal.hide("them-vai-tro-modal");
        });
    },
    layDanhSachVaiTro() {
      const payload = {
        ...this.requestInformation,
        ...this.requestForm,
        groupId: this.groupId,
        appId: this.appId,
      };
      this.isLoadingTable = true;
      this.$store
        .dispatch("group/layDanhSachVaiTroTheoGroup", payload)
        .then(() => {
          this.isLoadingTable = false;
        });
    },
    layDanhSachVaiTroNoiBo(danhSachVaiTro) {
      if (_isEmpty(danhSachVaiTro)) {
        return [];
      }

      return danhSachVaiTro.items.map((item, index) => {
        return {
          checkbox: null,
          stt:
            (this.requestInformation.pageIndex - 1) *
              this.requestInformation.pageSize +
            index +
            1,
          name: _isNil(item.name) ? "" : item.name,
          appName: _isNil(item.appName) ? "" : item.appName,
          displayName: _isNil(item.displayName) ? "" : item.displayName,
          id: item.roleId,
          roleId: item.roleId,
          thaoTac: "thaoTac",
        };
      });
    },
    layDanhSachIdVaiTro(danhSachVaiTro) {
      if (_isEmpty(danhSachVaiTro)) {
        return [];
      }
      return (danhSachVaiTro || []).map((item) => item.id);
    },
    moFormXoaVaiTro(id) {
      this.danhSachIdVaiTroMuonXoa = [id];
      this.$bvModal.show("xoa-vai-tro-group");
    },
    moFormXoaDanhSachVaiTro() {
      this.danhSachIdVaiTroMuonXoa = _cloneDeep(this.danhSachIdVaiTroDaChon);
      this.$bvModal.show("xoa-vai-tro-group");
    },
    xoaDanhSachVaiTro() {
      /*let danhSachVaiTro = this.danhSachIdVaiTro.filter(
        (x) => !this.danhSachIdVaiTroMuonXoa.includes(x)
      );*/
      const payload = {
        Id: this.chiTietGroup.id,
        Code: this.chiTietGroup.code,
        Name: this.chiTietGroup.name,
        AppId: this.chiTietGroup.appId,
        Description: this.chiTietGroup.description,
        LstUserInGroup: null,
        LstRole: this.danhSachIdVaiTroMuonXoa,
        LstPermission: null,
      };
      this.$store
        .dispatch("group/removeMapping", payload)
        .then((response) => {
          this.$toasted.clear();
          this.$toasted.global.showSuccessMessage({
            message: XOA_VAI_TRO_THUOC_GROUP_THANH_CONG,
          });
          this.danhSachIdVaiTroDaChon = this.danhSachIdVaiTroDaChon.filter(
            (x) => !this.danhSachIdVaiTroMuonXoa.includes(x)
          );
          this.$bvModal.hide("xoa-vai-tro-group");
          this.layDanhSachVaiTro();
          this.selectedVaiTro = [];
        })
        .catch(() => {
          this.$bvModal.hide("xoa-vai-tro-group");
        });
    },
    getFieldName() {
      if (_isEmpty(this.danhSachVaiTroNoiBo)) {
        return [];
      }
      return Object.keys(this.danhSachVaiTroNoiBo[0])
        .filter(
          (key) =>
            key !== "id" &&
            (!["checkbox", "thaoTac"].includes(key) || !this.readonly)
        )
        .map((key) => {
          return {
            key: key,
            label: BANG_VAI_TRO[key],
            tdClass: ["stt"].includes(key) ? "center" : "",
          };
        });
    },
  },
};
</script>

<style scoped>
.label-table {
  font-size: 16px !important;
  margin-top: 3px;
  margin-right: 5px;
  margin-left: -5px;
  font-weight: bold;
}
</style>
